// Action types for saving data
export const GET_DECLARATION_FORM_REQUEST = 'GET_DECLARATION_FORM_REQUEST';
export const GET_DECLARATION_FORM_SUCCESS = 'GET_DECLARATION_FORM_SUCCESS';
export const GET_DECLARATION_FORM_FAILURE = 'GET_DECLARATION_FORM_FAILURE';
export const GET_DECLARATION_FORM_RESET = 'GET_DECLARATION_FORM_RESET';
// Save data actions
export const getDeclarationFormRequest = (payload) => ({
    type: GET_DECLARATION_FORM_REQUEST,
    payload
});
export const getDeclarationFormSuccess = (payload) => ({
    type: GET_DECLARATION_FORM_SUCCESS,
    payload,
});
export const getDeclarationFormFailure = (error) => ({
    type: GET_DECLARATION_FORM_FAILURE,
    payload: error,
});
export const getDeclarationFormReset = () => ({
    type: GET_DECLARATION_FORM_RESET,
});
